import { startListening, isAnyOf } from '@bonanza-social/toolkit/state';
import {
  getAccount,
  selectAccountIsWithAMLAssessment,
  setAccount,
} from '@bonanza-social/account/state';
import { CommonActions, navigationRef } from '@bonanza-social/navigation';

startListening({
  matcher: isAnyOf(getAccount.fulfilled, setAccount),
  effect: (_, { getState, cancelActiveListeners }) => {
    cancelActiveListeners();

    const state = getState();
    const accountIsWithAmlAssessment = selectAccountIsWithAMLAssessment(state);
    if (accountIsWithAmlAssessment) {
      navigationRef.current?.dispatch(
        CommonActions.reset({
          index: 0,
          routes: [
            {
              name: 'AppNavigator',
            },
          ],
        }),
      );
      navigationRef.navigate('DetailsAttestation');
    }
  },
});
